"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react")),
    _uiKit = require("@devsta/ui-kit");

require("../styles/_list-items.scss");

function ListItem(_ref) {
  var iconName = _ref.iconName,
      text = _ref.text,
      price = _ref.price;
  return _react["default"].createElement(_react["default"].Fragment, null, _react["default"].createElement("div", {
    className: "list-items__row"
  }, _react["default"].createElement("div", {
    className: "list-items__row__description"
  }, _react["default"].createElement(_uiKit.Icon, {
    name: iconName,
    size: 17,
    color: "monkey"
  }), _react["default"].createElement("div", {
    className: "list-items__row__description__text"
  }, text)), _react["default"].createElement("div", {
    className: "list-items__row__description__cost"
  }, price)));
}

var _default = (0, _react.memo)(ListItem);

exports["default"] = _default;